import { Skeleton } from "@workspace/frontend-ui";
import type { FC } from "react";

const LoadingView: FC = () => (
  <div data-slot="loading-view" className="flex flex-col gap-2.5">
    <Skeleton className="h-37 rounded-3xl bg-accent" />
    <div className="flex flex-col gap-1.5">
      <Skeleton className="h-16 rounded-2xl bg-accent" />
      <Skeleton className="h-16 rounded-2xl bg-accent" />
      <Skeleton className="h-16 rounded-2xl bg-accent" />
    </div>
    <div className="flex gap-2.5">
      <Skeleton className="h-10 flex-1 rounded-xl bg-accent" />
      <Skeleton className="h-10 flex-1 rounded-xl bg-accent" />
    </div>
  </div>
);

export default LoadingView;
